<template>
  <div
    class="cnd-pagination cube-pagination"
    :class="{ hidden: hidden, 'fix-pagination': fixed }"
  >
    <slot name="pagination-left" />
    <el-pagination
      v-bind="$attrs"
      :small="small"
      :background="background"
      :page-size="limit"
      :total="total"
      :pager-count="pagerCount"
      :current-page.sync="currentPage"
      :layout="layout"
      :page-sizes="pageSizes"
      :popper-class="popperClass"
      :prev-text="prevText"
      :next-text="nextText"
      :disabled="disabled"
      :hide-on-single-page="hideOnSinglePage"
      v-on="$listeners"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
      <!-- :page-size="limit"
      :current-page.sync="activePage" -->
      <slot />
    </el-pagination>
  </div>
</template>

<script>
import '../../../../lib/styles/components/Pagination.scss'
import analytics from '../../../utils/analytics'
import { Pagination as ElPagination } from 'element-ui'
export default {
  name: 'Pagination',
  components: {
    ElPagination
  },
  props: {
    // 是否使用小型分页样式
    small: {
      type: Boolean,
      default: true
    },
    // 后端接口页码是否 0 开始
    hasZeroPagination: {
      type: Boolean,
      default: false
    },
    // 是否为分页按钮添加背景色
    background: {
      type: Boolean,
      default: false
    },
    // 每页显示条目个数，支持 .sync 修饰符
    // pageSize: {
    //   type: Number,
    //   default: 10
    // },
    // 总条目数
    total: {
      type: Number,
      default: 0
    },
    // 页码按钮的数量，当总页数超过该值时会折叠
    pagerCount: {
      type: Number,
      default: 5
    },
    // 当前页数，支持 .sync 修饰符
    // currentPage: {
    //   type: Number,
    //   default: 1
    // },
    // 组件布局，子组件名用逗号分隔
    // sizes, prev, pager, next, jumper, ->, total, slot
    layout: {
      type: String,
      default: 'total, prev, pager, next, sizes, jumper'
    },
    // 每页显示条目个数, 支持 .sync 修饰符
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50, 100, 200]
    },
    // 每页显示个数选择器的下拉框类名
    popperClass: {
      type: String,
      default: ''
    },
    // 替代图标显示的上一页文字
    prevText: {
      type: String,
      default: ''
    },
    // 替代图标显示的下一页文字
    nextText: {
      type: String,
      default: ''
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 一页时是否隐藏
    hideOnSinglePage: {
      type: Boolean,
      default: false
    },
    // 非el
    // 每页条数
    limit: {
      type: Number,
      default: 20
    },
    // 当前页
    page: {
      type: Number,
      default: 0
    },
    // 页码、页数切换事件
    event: {
      type: Function,
      default: () => {}
    },
    // 隐藏分页组件
    hidden: {
      type: Boolean,
      default: false
    },
    // 取消布局占位
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: this.isZero() ? this.page + 1 : this.page,
      pageSize: this.limit,
      defaultPage: JSON.parse(JSON.stringify(this.page))
    }
  },
  watch: {
    total: {
      handler(val) {
        this.totalHeightLight(val)
      },
      immediate: true
    },
    page() {
      this.currentPage = this.isZero() ? this.page + 1 : this.page
    }
  },
  mounted() {
    this.totalHeightLight(this.total)
  },
  methods: {
    totalHeightLight(num) {
      this.$nextTick(() => {
        if (this.$el) {
          const dom = this.$el.querySelector('.el-pagination__total')
          if (dom && dom.innerHTML) {
            const innerHtml = `共 <span class="suffix__total__color">${num}</span> 条`
            dom.innerHTML = innerHtml
          }
        }
      })
    },
    isZero() {
      return this.hasZeroPagination || this.defaultPage === 0
    },
    // 不知道干嘛的
    resetPage(page = 1) {
      this.currentPage = page
    },
    sizeChange(val) {
      this.currentPage = this.isZero() ? this.defaultPage + 1 : this.defaultPage
      this.event({
        limit: val,
        page: this.defaultPage
      })
    },
    currentChange(val) {
      this.event({
        limit: this.limit,
        page: this.isZero() ? val - 1 : val // 从 0 开始则减一页
      })
      try {
        const analyticsInstance = analytics.getAnalyticsInstance(this)
        analyticsInstance.reportEvent('pagination_click')
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
